import React from 'react';
import { Heart } from 'lucide-react';

const Footer = () => (
  <footer className="bg-[#FBEFE8]/50 mt-16">
    <div className="max-w-6xl mx-auto px-4 py-8 text-center">
      <div className="flex items-center justify-center gap-2 mb-4">
        <Heart className="text-[#E76C9B]" size={16} />
        <span className="text-[#5A8E6E] text-sm">The De Kort Wedding • February 21, 2026</span>
        <Heart className="text-[#E76C9B]" size={16} />
      </div>
      <p className="text-[#7A3E53]/70 text-sm">
        We can't wait to celebrate with you!
      </p>
    </div>
  </footer>
);

export default Footer;